import { buildApiUrl } from '../../../../shared_app/utils/buildApiUrl';
var YEARLY_REPORT_API = {
    dashboardData: buildApiUrl('/api/teachers/groups/:groupId/yearly_charts'),
    pdfReport: '/reports/yearly/pdf',
};
var YEARLY_ROUTES = {
    teacherStudentTimeline: '/teachers/g/:groupId/timeline/:studentId',
    supervisorStudentTimeline: '/administrators/schools/:schoolId/teachers/:teacherId/groups/:groupId/students/:studentId/timeline',
};
export { YEARLY_REPORT_API, YEARLY_ROUTES };
